/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/buttons/putOnHoldButton"/>

import * as ko from "knockout";
import { ReasonCodeOperationModalBase } 
  from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/reasonCodeOperationModal/reasonCodeOperationModalBase";
import { ReasonCodeOperationType } 
  from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces";
import { EntityType } 
  from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces";
import type = require("Core/Medius.Core.Web/Scripts/Medius/core/type");

export default class PutOnHoldButton {
    public task: any;
    public putOnHoldModel: any;
    public show: ko.Observable<boolean>;
    public ReasonCodeOperationModal: ko.PureComputed<any>;

    constructor(params: { task: any; putOnHoldModel: any; }) {
        this.task = params.task;
        this.putOnHoldModel = params.putOnHoldModel;
        this.show = ko.observable(false);

        this.ReasonCodeOperationModal = ko.pureComputed(() => {
            const documentId: number = this.task?.Document?.().Id?.();
            const hierarchyId: string = this.task?.Document?.().Company?.().HierarchyId?.();
            const taskDescription: string = this.task?.Description?.();
            const documentType: string = this.task?.Document?.().$type?.();
            const entityType: EntityType = 
                documentType.includes("Medius.Core.Entities.Integration.EDIDocumentImport") ?
                    EntityType.EdiDocumentImport :
                    EntityType.SupplierInvoice

            return {
                functionComponent: ReasonCodeOperationModalBase,
                props: {
                    show: this.show(),
                    documentId: documentId,
                    hierarchyId: hierarchyId,
                    modalType: ReasonCodeOperationType.PutOnHold,
                    task: taskDescription,
                    entityType: entityType,
                    currentDocumentType: type.getTypeName(documentType),
                    onClose: this.handleModalClose
                }
            };
        });
    }

    public handleModalClose = (wasConfirmed: boolean) => {
        if(wasConfirmed)
            this.putOnHoldModel.putOnHold();

        this.show(false);
    };

    public openOnHoldModal = () => {
        this.show(true);
    };
}
